import { Role } from '@/enums';

import { IBadge } from '@/components/common';

export const getRoleLabel = (role: Role | undefined): string => {
  if (!role) return 'Unknown';

  switch (role) {
    case Role.Reviewer:
      return 'Reviewer';
    case Role.SystemAdmin:
      return 'System Administrator';
    default:
      return 'Unknown';
  }
};

export const getRoleVariant = (role: Role): IBadge['variant'] => {
  switch (role) {
    case Role.SystemAdmin:
      return 'violet';
    case Role.Reviewer:
      return 'primary';
    default:
      return 'neutral-3';
  }
};
